import {useEffect, useState} from "react";
import {useResources} from "../../stores/ResourceProvider";
import {IIdleTimer, useIdleTimer} from 'react-idle-timer'
import {Typography} from "@mui/material";
import Tracking from "../Tracking";
import {useNavigate} from "react-router-dom";
import RoutesConfig from "../../RoutesConfig";
import {getISODateToday} from "../../stores/StoreUtilities";


const SessionTracker: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)
  const [state, setState] = useState<string>("Active")
  const [sessionStart, setSessionStart] = useState<Date | undefined>()
  const [lastActionDate, setLastActionDate] = useState<Date | undefined>()
  const [sessionDuration, setSessionDuration] = useState<number>(0)
  const [totalDuration, setTotalDuration] = useState<number>(0)
  const [idleTimeout, setIdleTimeout] = useState<number>(60_000 * 15)
  const [promptBeforeIdle, setPromptBeforeIdle] = useState<number>(60_000 * 5)
  const saveInterval = 60 * 1 // 1 minutes

  const { userStore, trackingAPI, confirm } = useResources()
  const navigate = useNavigate()

  useEffect(() => {
    const user = userStore.user
    setIsAuthenticated(user !== undefined)
    console.log(`Session ${user ? "Authenticated" : "Not Authenticated"}`)
    if (user) {
      if (user.isAdvisorOrAdmin) {
        setIdleTimeout(60_000 * 60)
      } else {
        setIdleTimeout(60_000 * 15)
      }
      console.log(`Session Start`)
      setSessionStart(new Date());
      setLastActionDate(undefined);
    }
  }, [userStore.user])

  const postSessionDuration = (duration: number) => {
    const user = userStore.user
    if (user && isAuthenticated && duration > 0 && state === "Active") {
      trackingAPI.postSession(user.accountId, user.id, getISODateToday(), duration)
        .then((result: any) => {
            if (result.duration) {
              setTotalDuration(result.duration)
            }
            console.log(`Session Posted: ${duration} seconds`, result)
          })
      .catch((error: any) => {
            console.log(`Session Post Failed: ${duration} seconds`, error)
          })
    }
  }

  const onActive = (event?: Event, idleTimer?: IIdleTimer): void => {
    console.log(`Session Active`)
    setSessionStart(new Date());
    setLastActionDate(undefined);
    setState("Active");
  }

  const onIdle = (event?: Event, idleTimer?: IIdleTimer): void => {
    console.log(`Session Idle`)
    if (sessionStart && lastActionDate) {
      const duration = Math.round((lastActionDate.getTime() - sessionStart.getTime()) / 1000)
      if (duration > 0) {
        setSessionDuration(sessionDuration + duration)
        postSessionDuration(duration)
      }
    }
    setSessionStart(undefined);
    setLastActionDate(undefined);
    setState("Idle");
    confirm.open = false
    userStore.signOut().then(() => {
      Tracking.event({action: "Session Time Out"})
      navigate(`${RoutesConfig.signIn.pathname}?timeout=1`)
    })
  }

  const onAction = (event?: Event, idleTimer?: IIdleTimer): void => {
    // console.log(`onAction: ${event?.type}`);
    const now = new Date()
    setLastActionDate(now)
    if (sessionStart) {
      const duration = Math.round((now.getTime() - sessionStart.getTime()) / 1000)
      if (duration >= saveInterval) {
        setSessionDuration(sessionDuration + duration)
        postSessionDuration(duration)
        setSessionStart(now);
      } else {
      }
    } else {
      console.log(`Session Start`)
      setSessionStart(now);
    }
  }

  const onPrompt = (event?: Event, idleTimer?: IIdleTimer): void => {
    confirm.show('RBC Session Expiring', <Typography variant="body2" sx={{mt:1}}>Your session is about to expire to protect your data.<br/>Would you like to extend the session?</Typography>,
      ['Yes', 'No'],
      () => {
        idleTimer!.reset()
        return true
      },
      () => {
        userStore.signOut().then(() => {
          Tracking.event({action: "User Sign Out"})
          navigate(RoutesConfig.signIn.pathname)
        })
      })
  }

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    onAction,
    onPrompt,
    timeout: idleTimeout,
    promptBeforeIdle: promptBeforeIdle,
    throttle: 1000,
    disabled: !isAuthenticated
  })

  return (
    null
    // <Typography variant="body2">Session: {totalDuration} seconds ({state})</Typography>
  )
}

export default SessionTracker